(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sm-recommendations"]) return;
  try {
    
  const handleRecommendationsIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    
    observer.unobserve(productRecommendationsSection);
    
    const url = productRecommendationsSection.dataset.url;
    
    fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('#product-recommendations');
      
        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });     
  };

  const productRecommendationsSection = document.querySelector('#product-recommendations');
  const recommendationsObserver = new IntersectionObserver(handleRecommendationsIntersection, {
    rootMargin: '0px', 
    treshold: '0.1'
  });
  
  recommendationsObserver.observe(productRecommendationsSection);

  const recommendationsCarousel = document.querySelector('#product-recommendations');
  const handleRecommendationsCarouselMutation = (mutationList, observer) => {
    const carousel = $('#recommendations-carousel');

    carousel.owlCarousel({
      items: 4,
      dots: false,
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        992: {
          items: 3
        },
        1200: {
          items: 4
        }
      }
    })

    $(".product__slider").owlCarousel({
    margin: 0,
    autoplay: false,
    items: 1,
    loop: false,
    dots: false,
    nav: true,
    navText: [
      '<i class="bx bx-chevron-left" ></i>',
      '<i class="bx bx-chevron-right" ></i>'
    ]
  });

    observer.disconnect();
  }
  
  const carouselObserver = new MutationObserver(handleRecommendationsCarouselMutation);
  carouselObserver.observe(recommendationsCarousel, { attributes: true, childList: true, subtree: true });

  } catch(e) { console.error(e); }
})();
})();
